import React, { useEffect } from "react";
import { Avatar } from "antd";
import { Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../../store/slices/userSlice";
import { Link } from "react-router-dom";
import Searchbar from "./searchbar";
import profileImage from "../../assets/icons/Avatar.png";
import AppNotifications from "./appNotifications";

const Header = () => {
  const dispatch = useDispatch();

  const image = useSelector((state) => state?.user?.response?.profileImage);
  const name = useSelector((state) => state?.user?.response);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchUsers());
    };
    fetchData();
  }, [dispatch]);
  return (
    <>
      <div className="p-0 h-10 bg-white flex justify-center">
        <div className="m-2 flex w-full flex-row sm:flex-row justify-between items-center w-full">
          <div className="relative flex  w-full justify-between">
            <Searchbar className="sm:w-7" />
            <div className="flex items-center">
              <AppNotifications />
              <div className="flex font-medium">
                {" "}
                <p className="hidden flex sm:block ml-1">{name?.firstName}</p>
                <p className="hidden flex sm:block ml-0.4"> {name?.lastName}</p>
              </div>
            </div>
            <Link to="/main/profile">
              <Avatar src={image ?? profileImage} className=" ml-2 h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>
      <div>
        {" "}
        <Divider className=" h-1px m-0" plain />
      </div>
    </>
  );
};

export default Header;
